import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Conditional from '../../common/conditional';
import Button from '../../themed/button';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import { transformListToOptions } from '../../../utils/utilities';

interface SWUTProbeItem {
    id: number;
    angle: number;
    frequency: string | number;
    size: string;
    range: number;
    scanVolume: number;
    corrVolume: number;
}

class SWUTProbeItemForm extends Form {
	state = {
		data: {
			angle: '',
            frequency: '',
            size: '',
            range: 0,
            scanVolume: 0,
            corrVolume: 0,
		},
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
        id: Joi.number().optional().label('ID'),
        angle: Joi.number().min(0).required().label('Angle (deg)'),
        frequency: Joi.alternatives(Joi.string(), Joi.number().positive()).required().label('Frequency (Mhz)'),
        size: Joi.string().required().label('Size / Dia (mm)'),
        range: Joi.number().min(25).required().label('Range (mm)'),
        scanVolume: Joi.number().min(10).max(100).required().label('Scanning dB'),
        corrVolume: Joi.number().min(0).max(50).required().label('Trans Corr dB'),
    };

    static propTypes = {
        probeAngles: PropTypes.array,
        initialProbeItem: PropTypes.object,
        onDeleteItem: PropTypes.func,
        onSave: PropTypes.func,
    };

    componentDidMount(): void {
        if (this.props.initialProbeItem) {
            this.setState({ data: this.props.initialProbeItem });
        }
    }
	
	doSubmit = () => {
		this.props.onSave(this.state.data);

        if (!this.props.initialProbeItem) {
            this.resetData();
        }

        toastService.success('Data Saved Successfully!');
	};

    resetData = () => {
        this.setState({
            data: {
                angle: '',
                frequency: '',
                size: '',
                range: 0,
                scanVolume: 0,
                corrVolume: 0,
            },
        })
    };


	render() {
		return (
            <form autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(this.props.probeAngles),
                            name: 'angle',
                            label: 'Angle (deg)',
                            placeholder: 'Select Angle (deg)',
                        })}
                    </div>

                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(FREQUENCIES),
                            name: 'frequency',
                            label: 'Frequency (Mhz)',
                            placeholder: 'Select Frequency (Mhz)',
                        })}
                    </div>

                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(SIZES),
                            name: 'size',
                            label: 'Size / Dia (mm)',
                            placeholder: 'Select Size / Dia (mm)',
                        })}
                    </div>
                </div>

                <div className="my-4 divider"></div>
                
                <div className="row">
                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(RANGES),
                            name: 'range',
                            label: 'Range (mm)',
                            placeholder: 'Select Range (mm)',
                        })}
                    </div>
                    
                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(SCAN_VOLUMES),
                            name: 'scanVolume',
                            label: 'Scaning dB',
                            placeholder: 'Select Scaning dB',
                        })}
                    </div>

                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(CORR_VOLUMES),
                            name: 'corrVolume',
                            label: 'Trans Corr. dB',
                            placeholder: 'Select Trans Corr. dB',
                        })}
                    </div>
                </div>
                
                <div className="my-4 divider"></div>

                <div className="d-flex justify-content-end">
                    <Conditional isVisible={!!this.props.onDeleteItem}>
                        <div className="me-3">
                            <Button
                                onClick={this.props.onDeleteItem} 
                                icon="trash"
                                label="Delete" 
                                type="button"
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>
                    </Conditional>

				    {this.renderButton('Save')}
                </div>
            </form>
		);
	}
}

const SIZES = ['8x9', '20x22'];
const FREQUENCIES = ['N/A', 1, 2, 2.5, 5, 10];
const RANGES = _.range(25, 1001, 25);
const SCAN_VOLUMES = _.range(10, 101);
const CORR_VOLUMES = _.range(0, 51);

export type { SWUTProbeItem }
export default SWUTProbeItemForm;
